import { useState, useEffect } from 'react';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 z-40 bg-[#E31B23] text-white w-12 h-12 rounded-full shadow-lg hover:bg-[#C41820] transition-all duration-300 flex items-center justify-center group hover:scale-110 cursor-pointer"
          aria-label="Retour en haut"
        >
          <i className="ri-arrow-up-line text-2xl group-hover:translate-y-[-2px] transition-transform duration-300"></i>
        </button>
      )}
    </>
  );
};

export default ScrollToTop;
